import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import ImgMediaCard from './cardDeals';
import axios from '../../utils/axios';
import { useTranslation } from 'react-i18next';
import '../../i18n';

//import { useNavigate } from 'react-router-dom';
//import { Button } from '@mui/material';
//const userRole = localStorage.getItem('userRole');

const DealsShow = () => {
  const { t } = useTranslation(); // t is the translation function
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  //const [userRole] = useState(localStorage.getItem('userRole'));
  //const [userRole, setUserRole] = useState(localStorage.getItem('userRole')); // Store user role in state
  //const navigate = useNavigate(); // Initialize useNavigate hook

  // Fetch data from the backend
  useEffect(() => {
    const fetchDeals = async () => {
      try {
        const response = await axios.get('/deals');
        const sortedDeals = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));  // Sort by createdAt in descending order
        setDeals(sortedDeals);  // Assuming response.data is an array of deals
      } catch (error) {
        console.error('Error fetching deals:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDeals();
  }, []);

  if (loading) return <p>Please wait for loading the data. It will take a couple minutes. Please be patient</p>;  // Show loading text while data is being fetched

  return (
    <section className="white-section" id="Menu">
      <div className="container-fluid">
        {/* {userRole === 'admin' && (
        <Button variant="contained" color="success" style={{ marginBottom: '10px' }} onClick={() => navigate('/discover/new')}>
          Create New Deal
        </Button>
        )} */}
        <h2 className="section-heading">{t('landingPage:deals.all-deals-title')}</h2>
        <p>{t('landingPage:deals.all-deals-context')}</p>
        <Grid container spacing={2}>
          {/* Map over the 'deals' array and render a card for each deal */}
          {deals.map((deal) => (
            <Grid item xs={12} sm={6} md={4} key={deal._id}>
              <ImgMediaCard
                image={deal.imageLink}
                name={deal.title}
                description={deal.description}
                id={deal._id}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </section>
  );
};

export default DealsShow;
